import { Search } from "lucide-react";
import { forwardRef, type InputHTMLAttributes, type ReactNode, useId } from "react";
import { cn } from "../../lib/cn";

interface SearchInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label: ReactNode;
  wrapperClassName?: string;
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(function SearchInput(
  { className, id, label, wrapperClassName, ...props },
  ref,
) {
  const generatedId = useId();
  const inputId = id ?? generatedId;

  return (
    <div className={cn("relative", wrapperClassName)}>
      <label className="sr-only" htmlFor={inputId}>
        {label}
      </label>
      <Search
        aria-hidden="true"
        className="pointer-events-none absolute left-[var(--space-3)] top-1/2 size-[var(--space-4)] -translate-y-1/2 text-[var(--color-text-tertiary)]"
      />
      <input
        className={cn(
          "type-label h-[var(--field-h)] w-full rounded-[var(--radius-md)] border border-[var(--color-border)] bg-[var(--color-surface)] pl-[calc(var(--space-3)+var(--space-5))] pr-[var(--space-3)] text-[var(--color-text)] placeholder:text-[var(--color-text-tertiary)] hover:border-[var(--color-border-strong)] focus:border-[var(--color-border-focus)] focus:outline-none focus:[box-shadow:var(--focus-ring)]",
          className,
        )}
        id={inputId}
        ref={ref}
        type="search"
        {...props}
      />
    </div>
  );
});
